import PageCheckoutSuccess from '@/pages/PageCheckoutSuccess'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: PageCheckoutSuccess,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}